import { CustomerDataProviderProps } from '../types';
import { useCustomers } from '../hooks/useCustomers';
import { CustomersContext } from './CustomersContextObject';

/**
 * Provides customer data and related actions to its children via React Context.
 *
 * This provider uses clean architecture patterns through use cases and repository layer.
 * It provides a centralized state management solution for customer data across the application.
 *
 * @param {CustomerDataProviderProps} props - The props for the provider, including children components.
 * @returns {JSX.Element} The context provider wrapping its children.
 *
 * @example
 * <CustomerDataProvider>
 *   <CustomerList />
 * </CustomerDataProvider>
 */
export const CustomerDataProvider = ({ children }: CustomerDataProviderProps) => {
  const customerHook = useCustomers();

  return (
    <CustomersContext.Provider value={customerHook}>
      {children}
    </CustomersContext.Provider>
  );
};

;

